import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13.532 4.4c-.604.01-1.345.443-1.505 1.625-.107.8-.294 1.938-.519 3.287h2.607a.7.7 0 0 1 0 1.4h-2.84l-.038.226c-.343 2.066-.732 4.46-1.064 6.876-.146 1.06-.526 1.871-1.084 2.419a2.617 2.617 0 0 1-1.945.765C5.82 20.95 4.55 19.89 4.55 18.336a.7.7 0 0 1 1.4 0c0 .713.584 1.24 1.245 1.263.31.011.635-.093.914-.366.283-.278.562-.774.677-1.61a251.46 251.46 0 0 1 1.07-6.911H7.104a.7.7 0 1 1 0-1.4h2.985c.242-1.45.44-2.65.551-3.474.246-1.826 1.532-2.816 2.87-2.838 1.325-.021 2.599.934 2.637 2.627a.7.7 0 1 1-1.4.031c-.019-.863-.599-1.268-1.215-1.258Zm.082 9.202a.7.7 0 0 1 .99-.01l1.828 1.787 1.829-1.788a.7.7 0 0 1 .978 1.001l-1.806 1.766 1.806 1.767a.7.7 0 0 1-.979 1l-1.828-1.788-1.828 1.788a.7.7 0 1 1-.979-1l1.806-1.767-1.806-1.766a.7.7 0 0 1-.01-.99Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
